/* eslint-disable no-template-curly-in-string */
import commons from "./commons/id"
import components from "./components/id"
import forms from "./forms/id"
import models from "./models/id"
import screens from "./screens/id"
import yup from "./yup/id"

export default {
  "bottomMenu" : {
    "home": "Beranda",
    "graph": "Grafik",
    "quickInput": "Input",
    "help": "Bantuan",
    "profile": "Akun"
  },
  "common": {
    "ok": "OK",
    "yes": "Ya",
    "cancel": "Batal",
    "back": "Kembali",
    "close": "Tutup",
    "next": "Selanjutnya",
    "done": "Selesai",
  },
  "errors": {
    "invalidEmail": "Alamat email tidak valid."
  },
  "welcomeScreen": {
    "poweredBy": "POWERED BY IGNITE",
    "readyForLaunch": "Ready for launch.",
    "continue": "CONTINUE"
  },
  "demoScreen": {
    "howTo": "HOW TO",
    "title": "What’s In This Stack?",
    "tagLine": "Congratulations, you’ve got a very advanced React Native app template here.  Take advantage of this boilerplate!",
    "reactotron": "Demo Reactotron",
    "demoList": "Demo List",
    "androidReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running, run adb reverse tcp:9090 tcp:9090 from your terminal, and reload the app.",
    "iosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "macosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "webReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "windowsReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app."
  },
  "demoListScreen": {
    "title": "Demo List"
  },
  "errorScreen": {
    "title": "Something went wrong!",
    "friendlySubtitle": "This is the screen that your users will see in production when an error is thrown. You'll want to customize this message (located in `app/i18n/en.json`) and probably the layout as well (`app/screens/error`). If you want to remove this entirely, check `app/app.tsx` for the <ErrorBoundary> component.",
    "traceTitle": "Error from %{name} stack",
    "reset": "RESET APP"
  },

  "splashScreen": {
    "splashScreenTitle": "Aplikasi Manajemen Budidaya Tambak Udang",
    "releaseTitle": "Apa yang baru di {{version}}",
    "releaseMessage": "",
    "hashtag": "#HadirMembantu"
  },
  "onboardScreen": {
    "onboard1": "Selamat datang di Jala",
    "onboard2": "Catat data meski pada kondisi Offline",
    "onboard3": "Pantau kondisi kolam di mana pun",
    "onboard4": "Budidaya lebih mudah jika dilakukan bersama",
    "onboard5": "Info harga udang dan kabar udang terbaru",
    "onboard6": "Terhubung dengan alat ukur kualitas air Jala Baruno",
    "login": "Masuk",
    "register": "Daftar",
    "justTry": "Hanya ingin mencoba?",
    "tryDemo": "Coba demo"
  },
  "socialLoginScreen": {
    "socialLoginScreenTitle": "Aplikasi Manajemen Budidaya Tambak Udang",
    "loginWithApple": "Masuk dengan Apple",
    "loginWithGoogle": "Masuk dengan Google",
    "loginWithFacebook": "Masuk dengan Facebook",
    "or": "Atau",
    "loginWithEmail": "Masuk dengan email Anda",
    "loginWithPhoneEmail": "Masuk dengan No HP atau Email"
  },
  "loginScreen": {
    "welcome": "Selamat datang",
    "loginSubtitle": "Silahkan masuk dengan alamat Email yang terdaftar",
    "email": "Email",
    "emailAddress": "No HP atau Alamat Email",
    "password": "Kata Sandi",
    "forgotPassword": "Lupa kata sandi?",
    "login": "Masuk",
    "failedAlert": "Gagal Masuk",
    "failedAlertSubtitle": "Pastikan No Handphone/Email dan Kata Sandi Anda sudah benar"
  },
  "passwordResetScreen": {
    "resetPassword": "Reset kata sandi",
    "forgotPassword": "Lupa kata sandi?",
    "InputForgotPasswordEmail": "Masukkan email Anda",
    "ButtonForgotPassword": "Kirim Link Reset Kata Sandi",
    "forgotPasswordSubtitle": "Masukkan alamat email anda, kami akan mengirimkan panduan link reset kata sandi.",
    "guideTitle": "Panduan reset telah terkirim",
    "guideMessage": "cek email anda untuk mengatur ulang kata sandi",
    "failedTitle": "Reset kata sandi gagal",
    "errorMessage": "Kami tidak dapat menemukan pengguna dengan alamat surel tersebut",

    "phoneModeButton": "Gunakan Nomor HP",
    "emailModeButton": "Gunakan Email",
    "sendOTPButton": "Kirim Kode Verifikasi",

    "forgotPasswordWithPhoneSubtitle": "Masukkan no. hp anda, kami akan mengirimkan kode verifikasi untuk reset kata sandi.",
    "inputOTPTitle": "Masukkan kode verifikasi",
    "inputOTPSubtitle": "Kode verifikasi telah dikirimkan ke nomor {{phone}}. Silahkan masukkan kode verifikasi di bawah ini untuk melanjutkan. Tidak menerima kode verifikasi?",
    "resendOTP": "Kirim ulang kode",
    "inputNewPassword": "Masukkan kata sandi baru Anda",
    "successTitle": "Password Berhasil Diperbarui",
    "successSubtitle": "Kata sandi Anda telah berhasil diperbarui. Sekarang Anda dapat masuk kembali dengan kata sandi baru.",

    "sendWhatsappVerification": "Kirim Kode Verfikasi Via WhatsApp",
    "sendSMSVerification": "Kirim Kode Verifikasi Via SMS",

    "modalTitleSuccess": "Kode berhasil dikirim ulang",
    "modalSubtitleSuccess": "Anda dapat meminta ulang kode OTP 2 kali dalam sehari. Jika melebihi batas, coba lagi besok. Terima kasih telah menggunakan layanan kami.",
    "modalTitleFailed": "Limit Kirim Kode",
    "modalSubtitleFailed": "Anda telah mencapai batas permintaan kode OTP Anda untuk hari ini. Silakan coba kembali besok untuk mendapatkan kode OTP baru atau Hubungi Kami"
  },
  "registerScreen": {
    "register": "Daftar",

    "subPatent": "Dengan mendaftar, Anda menyetujui ",
    "jalaPrivacyAndPolicy": "Aturan Penggunaan dan Kebijakan Privasi Jala.",
    "registerNow": "Daftar Sekarang",
    "phoneDisclaimer": "Pastikan nomor yang Anda masukkan benar, karena Anda hanya dapat mengubah nomor 1 kali dalam 24 jam."
  },

  "initialSyncScreen": {
    "loading": "Mohon tunggu\nsedang mengambil data..."
  },

  "registerForm": {
    "name": "Nama Lengkap",
    "phone": "Nomor HP",
    "email": "Email",
    "password": "Kata Sandi",
    "passwordConfirmation": "Ulang Kata Sandi",
    "type": "Pekerjaan",
    "occupation": "Sebagai",
    "birthdate": "Tanggal Lahir",
    "knowjalafrom": "Dari mana Anda mengetahui JALA?",

    "namePlaceholder": "Nama Anda",
    "phonePlaceholder": " ",
    "emailPlaceholder": "Alamat Email",
    "passwordPlaceholder": "Kata Sandi",
    "passwordConfirmationPlaceholder": "Ulang Kata Sandi",
    "farmers": "Pembudidaya",
    "nonFarmers": "Non Pembudidaya",
    "occupationPlaceholder": "Pilih",
    "birthdatePlaceholder": "Pilih",

    "passwordConfirmationDoesntMatch": "${path} tidak sesuai",

    "social_media": "Media Sosial (Facebook, Instagram, TikTok, Youtube)",
    "online_ads":"Iklan Online",
    "blog_or_article": "Blog/Artikel",
    "offline_attribute": "Atribut Offline (Brosur, Katalog, Spanduk)",
    "friend_recomendation": "Rekomendasi Teman",
    "community": "Komunitas",
    "online_event": "Acara Online (Webinar)",
    "offline_event": "Acara Offline",
    "other": "Lainnya"
  },

  "profileScreen": {
    "profile": "Akun",
    "verified": "Terverifikasi",
    "unverified": "Tidak Terverifikasi",
    "editProfile": "Ubah Profil",
    "farmProfile": "Tambak Terhubung",
    "security": "Keamanan",
    "settingAccount": "Pengaturan",
    "privacyMenu": "Kebijakan Privasi",
    "choice": "Pilihan",
    "interesTitle": "Personalisasi Tampilan",
    "language": "Bahasa",
    "support": "Bantuan",
    "helpMenu": "Bantuan",
    "faq": "FAQ",
    "whatsapp": "WhatsApp Jala",
    "emailMenu": "Email",
    "appsTutorial": "Tutorial JALA App",
    "joinTelegram": "Gabung Grup Telegram",
    "theOther": "Lainnya",
    "rateUs": "Beri Jala Rating",
    "appInfo": "Info Aplikasi",
    "exitMenu": "Keluar",
    "changeLanguage": "Ubah Bahasa",
    "messenger": "Facebook Messenger",
    "logoutTitle": "Cek sebelum keluar",
    "logoutSubtitle": "Pastikan data offline bernilai '0' sebelum keluar dari aplikasi. Data offline yang belum diupload dapat terhapus jika Anda keluar/logout",
    "logoutButtonConfirm": "Keluar",
    "logoutButtonCancel": "Kembali"
  },

  "settingAccount": {
    "setting": "Pengaturan",
    "changePassword": "Ubah kata sandi",
    "delete": "Hapus Akun",
    "resetOfflineDatabase": "Set Ulang Database Offline",
    "resetOfflineDatabaseWarn": "Data offline yang belum diupload akan terhapus.",
  },

  "changePasswordForm": {
    "currentPassword": "Kata sandi saat ini",
    "password": "Kata Sandi Baru",
    "passwordConfirmation": "Ulang Kata Sandi Baru",
    "success": "Kata sandi berhasil diubah",
    "oldPasswordError": "Kata Sandi Saat Ini Tidak Sesuai",
    "failedInput": "Data gagal disimpan, coba ulangi",


    "currentPasswordPlaceholder": "Kata sandi saat ini",
    "passwordPlaceholder": "Kata Sandi Baru",
    "passwordConfirmationPlaceholder": "Ulang Kata Sandi Baru",

    "passwordConfirmationDoesntMatch": "${path} tidak sesuai"
  },

  "deleteScreen": {
    "term1": "Data Siklus, kolam, dan tambak akan terhapus dan tidak bisa diakses kembali.",
    "term2": "Akun dan data pribadimu akan terhapus.",
    "term3": "Anda tidak dapat terhubung dengan tambak lainnya.",
    "deletingAccount": "Yakin ingin menghapus akunmu ?",
    "termDelete": "Jika Akunmu di hapus : ",
    "delete": "Hapus",
    "deleteConfirm": "Konfirmasi Kata Sandi",
    "agreement": "Saya memahami dan menerima semua risiko di atas terkait penghapusan akun.",
    "disclaimer": "Akun yang telah terhapus tidak dapat dikembalikan lagi. Jika Anda yakin, mohon isi kata sandi Anda untuk menghapus akun.",
    "placeholder": "Konfirmasi kata sandi"
  },

  "editProfileForm": {
    "header": "Ubah Profil",
    "photo": "Ubah Foto Profil",
    "name": "Nama Lengkap",
    "email": "Email",
    "phone": "Nomor HP",
    "gender": "Jenis Kelamin",
    "regionId": "Alamat",
    "save": "Simpan",
    "man": "Laki-laki",
    "woman": "Perempuan",
    "takePhoto": "Ambil foto",
    "fromGallery": "Dari galeri",

    "namePlaceholder": "Nama lengkap",
    "emailPlaceholder": "Alamat email",
    "phonePlaceholder": "Nomor HP",
    "genderPlaceholder": "Pilih Jenis Kelamin",
    "regionIdPlaceholder": "Pilih Alamat"
  },

  "connectedFarm": {
    "header": "Tambak Terhubung",
    "as": "Sebagai",
    "member": "Anggota",
    "emptyTitle": "Belum ada tambak",
    "emptySubtitle": "Buat tambak di halaman beranda atau minta pemilik tambak mengundang Anda.",
    "farmProfile": "Profil Tambak",
    "farmLabel": "Nama tambak",
    "address": "Alamat",
    "area":"Luas area",
    "addMember": "Tambah anggota",
    "owner": "Pemilik",
    "admin": "Admin",
    "operator": "Operator dan tenaga kolam",
    "laboran": "Laboran",
    "viewer": "Viewer",
    "add": "Tambah Anggota",
    "roleId": "Peran",
    "roleIdPlaceholder": "Pilih Peran",
    "info": "Informasi",
    "access1": "Mengubah data budidaya",
    "access2": "Melihat data budidaya",
    "access3": "Akses grafik analisis (web app)",
    "access4": "Melihat & mengubah data stok tambak (web app)",
    "access5": "Export laporan budidaya (web app)",
    "access6": "Melihat dan mengubah data keuangan tambak (web app)",
    "access7": "Export laporan keuangan tambak (web app)",
    "access8": "Tambah & hapus anggota",
    "access9": "Merubah akses setiap anggota",
    "changeAccess": "Ubah Akses",
  },


  "storybook": {
    "placeholder": "Placeholder",
    "field": "Field"
  },

  "pondScreen": {
    "addFarm": "Buat Tambak",
    "emptyFarm": "Belum ada tambak",
    "createPond": "Buat Kolam",
    "addPond": "Tambah Kolam",
    "emptyPond": "Belum ada kolam",
    "startCycle": "Mulai Siklus",
    "cycleHistory": "Riwayat Siklus",
    "ClosedAt": "Ditutup pada",
    "age": "Umur",
    "temperature": "Suhu",
    "do": "DO",
    "ph": "pH",
    "salinity": "Salinitas",
    "weather": "Cuaca",
    "color": "Warna"
  },

  "graphScreen": {
    "header": "Grafik",
    "message": "Pilih tambak, kolam dan siklus\nterlebih dahulu untuk menampilkan grafik",
    "farming": "Budidaya",
    "waterQuality": "Kualitas Air",
    "costAnalysis": "Biaya",

    "profitPotential": "Potensi Revenue",
    "productionCost": "Estimasi HPP ({{currency}}/kg)",
    "incomePotential": "Potensi Profit",
    "estimationFeedCost": "Biaya Pakan",
    "estimatedSellingPrice": "Estimasi Harga Jual",
    "production": "Estimasi Biaya Produksi",
    "active": "Siklus Aktif",
    "nonactive": "Siklus Tidak Aktif",
    "revenuePotentialDisclaimer": "Potensi revenue = (estimasi biomassa x harga jual udang) + panen ({{currency}})",
    "profitPotentialDisclaimer": "Potensi profit = potensi revenue - estimasi total biaya",
    "profitPotntialDisclaimerSubtitle": "Estimasi total biaya diperoleh melalui pendekatan biaya pakan sebagai kontribusi terbesar + estimasi biaya lainnya.",
    "hppEstimation": "Estimasi HPP = ",
    "costEstimation": "estimasi biaya produksi ({{currency}})",
    "biomassEstimation": "estimasi biomasa + panen (kg)",
    "hppEstimationDisclaimer": "Estimasi total biaya diperoleh melalui pendekatan biaya pakan sebagai kontribusi terbesar + estimasi biaya lainnya.",
    "productionDisclaimer": "Biaya produksi = biaya benur + biaya pakan + estimasi biaya lainnya",
    "sellingPriceDisclaimer": "Harga jual = estimasi biomassa x harga size pada HPP",
    "sellingPriceDisclaimer2": "*Perhitungan prediksi biaya ini tidak termasuk listrik, gaji karyawan dan biaya persiapan budidaya.",
    "completeDataDisclaimer": "Lengkapi data pakan Anda untuk mendapatkan estimasi yang lebih akurat",
    "feedCostDisclaimer": "Biaya pakan = total pakan (kg) x harga pakan",
    "cogsDisclaimer1": "*<b>Biaya Listrik</b>, <b>gaji karyawan</b> dan <b>biaya persiapan budidaya</b> tidak termasuk dalam perhitungan estimasi.",
    "cogsDisclaimer2": "*Nilai estimasi ini hanya sebagai alternatif informasi untuk menilai aspek operasional budidaya."
  },

  "diseaseScreen": {
    "shrimpDisease": "Penyakit Udang",
    "diseaseSearchPlaceholder": "Cari kata kunci penyakit",
    "listDisease": "Daftar Penyakit",
    "read": "Baca",
    "empty": "Oops, tidak ada hasil yang ditemukan.\nGunakan kata kunci lain",
    "mostSearch": "atau lihat penyakit yang paling dicari",
  },

  "newsScreen": {
    "shrimpNews": "Kabar Udang",
    "newsSearchPlaceholder": "Cari Kabar Udang",
    "latestNews": "Berita Terbaru",
    "allCategory": "Semua Kategori",
    "other": "Lihat Lainnya",
    "search": "Hasil pencarian dari kata '{{search}}'",
    "searchByCategory": "atau cari berdasarkan kategori",
    "category": "Kategori"
  },

  "autoFeederScreen": {
    "title": "Auto Feeder",

    "connect": "Sambungkan",
    "mode": "Mode",
    "typeCommand": "Ketik Perintah",
    "send": "Kirim",
    "failedToConnect": "Gagal Menyambungkan"
  },

  "autoFeederPondCreateScreen": {
    "title": "Tambah Auto Feeder",
    "successAddSubtitle": "Asto Anda berhasil ditambahkan!",
    "successModalSubtitle": "Sebelum menggunakan Asto, penting untuk melakukan konfigurasi koneksi, mode putar dan juga test run"
  },

  "autofeederCreateQRScanScreen": {
    "title": "Pindai Kode QR",
    "description": "Arahkan kamera ke gambar kode qr yang tertera pada controller asto",
    "unrecognizedModalTitle": "Kode QR tidak dikenali",
    "unrecognizedModalSubtitle": "Kode QR ini tidak terdaftar dalam database kami saat ini, coba untuk memindai kembali."
  },

  "autoFeederPondCreateWizardScreen": {
    "connectionSetup": "Setup Koneksi",
    "modeSetup": "Setup Mode",
    "testRunSetup": "Uji Coba Asto",
    "connectAsto": "Hubungkan Asto",
    "connectAstoSubtitle": "Saat mengoperasikan Asto, Anda perlu menghubungkan asto melalui jaringan Bluetooth atau Wifi",
    "connectAstoWifi": "Hubungkan Asto dengan Wifi (opsional)",
    "connectAstoWifiSubtitle": "Anda juga dapat menghubungkan Asto dengan jaringan wifi yang ada di Tambak",
    "testRunSubtitle": "Uji coba controller asto, pastikan controller terhubung dengan Autofeeder Anda",
    "testRunModalTitle": "Apakah Autofeeder berjalan?",
    "hold": "Tekan untuk memulai",
    "bluetooth": "Bluetooth",
    "bluetoothDisconnected": "Terputus. Sentuh untuk menghubungkan",
    "ssid": "SSID Wifi",
    "password": "Kata Sandi Wifi",
    "connect": "Hubungkan",
    "optional": "*Anda dapat melewati tahap ini",
    "modeSetupSubtitle": "Pilih salah satu mode yang sesuai dengan kondisi dikolam Anda saat ini",
    "normal": "Normal",
    "normalDescription": "Pemberian pakan pada jadwal tertentu dalam sehari",
    "continue": "Kontinu",
    "continueDescription": "Pemberian pakan secara terus menerus sampai berakhirnya waktu pakan",
    "timesPerDay": "Jumlah Pemberian",
    "debit": "Debit Pakan",
    "intervalPeriod": "Durasi Pakan",
    "onTime": "Timer ON",
    "interval": "Time Interval",
    "startTime": "Jam Mulai",
    "endTime": "Jam Selesai",
    "debitUnit": "gr/detik",
    "intervalPeriodUnit": "menit",
    "onTimeUnit": "detik",
    "timesPerDayUnit": "kali/hari",
    "debitError": "Minimal pemberian pakan 5 dan maksimal 7 perhari",
    "intervalHelper": "Interval by system ",
    "onHelper": "Timer ON by system ",
    "timerOnInfo": "Durasi motor sekali putar",
    "successModalTitle": "Selamat Anda telah menyelesaikan konfigurasi Asto",
    "successModalSubtitle": "Selanjutnya Anda akan diarahkan untuk mengenal fungsi-fungsi dari fitur Asto",
    "infoTestRun": "Test Run akan berjalan sesuai ",
    "infoTestRunOnTime": "Timer ON: {{onTime}} detik",
    "throwingDistance": "Jarak Lontar",
    "short": "Pendek",
    "medium": "Sedang",
    "long": "Jauh",
    "manual": "Atur durasi putaran (manual)",
    "duration": "Durasi Putaran",
    "timesPerDayHelper": "Anda bisa mengisi antara 1 hingga 7 kali/hari",
    "distanceHelper": "Jarak lontaran pakan bergantung dengan ukuran pakan"
  },

  "autoFeederPondDetailScreen": {
    "title": "Detail Asto",

    "mode": "Mode",
    "debit": "Debit Pakan",
    "throwDebit": "Debit Pakan",
    "startTime": "Jam Mulai",
    "endTime": "Jam Selesai",
    "onTime": "Timer ON",
    "timesPerDay": "Pakan/hari",
    "timesPerPeriod": "Lemparan/jam pakan",
    "intervalPerPeriod": "Interval Lemparan",
    "intervalPeriod": "Durasi pakan",
    "duration": "Durasi",
    "frequency": "Frekuensi",
    "quantity": "Pakan",
    "interval": "Timer Interval",
    "onTimeOverride": "Timer ON Manual",
    "intervalOverride": "Timer Interval Manual",
    "lastOnAt": "Terakhir ON",
    "previousOnAt": "ON Sebelumnya",
    "nextOnAt": "ON Selanjutnya",

    "intervalShort": "Interval",
    "override": "Manual",

    "debitUnit": "gr/dtk",
    "throwDebitUnit": "gr/lontar",
    "onTimeUnit": "dtk",
    "timesPerDayUnit": "kali",
    "timesPerPeriodUnit": "kali",
    "intervalPeriodUnit": "menit",
    "intervalUnit": "menit",

    "intervalUnitShort": "m",

    "today": "Hari ini",
    "nextDay": "Hari berikutnya",
    "date": "Tanggal",
    "time": "Jam Pakan",

    "feedData": "Data Pakan Siklus",
    "openFeedData": "Buka Data Pakan",
    "setFeedData": "Gunakan Data Pakan",

    "portion": "Porsi (kg)",
    "feedPortion": "Porsi Pakan",
    "feedPortionHelper": "Porsi Pakan 1 dari %{total} Auto Feeder",

    "failedToConnect": "Gagal Menyambungkan",
    "uploadOrResetFirst": "Unggah atau reset terlebih dahulu",

    "normal": "Normal",
    "continuous": "Kontinu",

    "feedTableTitle": "Tabel Pakan",
    "feedCycleTitle": "Data Pakan Siklus",
    "todayFeedTitle": "Pakan Hari Ini",

    "weeklySchedule": "Jadwal Pakan Seminggu",
    "detail": "Rincian(kg)",
    "detailInfo": "Rincian mengikuti jam pakan",
    "intervalInfo": "Jeda waktu antar putaran",
    "durationInfo": "Durasi motor sekali putar",

    "feedCycleDataDescription": "Anda bisa menggunakan data pakan yang telah diinputkan didalam fitur Input Pakan",
    "disconnectedWarning": "Koneksi Terputus",
    "disconnectedWarningDescription": "Anda tidak terhubung dengan Asto",

    "confirmationSaveTitle": "Simpan Data?",
    "confirmationSaveSubtitle": "Apakah kamu yakin ingin menyimpan data?",
    "confirmationUploadTitle": "Upload Data?",
    "confirmationUploadSubtitle": "Apakah kamu yakin ingin mengupload data?",
    "confirmationResetTitle": "Reset Data?",
    "confirmationResetSubtitle": "Apakah kamu yakin ingin mereset data?",

    "intervalDataTitle": "Data Interval",
    "feedWarning": "Jumlah pakan yang ada di Tank menipis, Cek sekarang!",

    "uploadWarning": "Ada perubahan data ASTO yang belum di upload.",
    "uploadData": "Upload Data",

    "feedDataTitle": "Data Pakan",
    "failedConnect": "Gagal Terhubung. Sentuh untuk menghubungkan",

    "uploadBannerTitle": "Data belum dikirim ke ASTO",
    "uploadBannerSubtitle": "Upload perubahan data untuk memperbarui pengaturan di autofeeder.",
    "uploadBannerButton": "KIRIM",
    "uploadSuccessTitle": "Upload Berhasil!",
    "uploadSuccessSubtitle": "Pengaturan berhasil disimpan ke ASTO",
    "sendToAsto": "Kirim ke ASTO",

    "advancedSetting": "Pengaturan Lanjutan",

    "calibrationTitle": "Pakan habis tidak sesuai perkiraan?",
    "calibrationButton": "Sesuaikan Debit Pakan",
    "calibrationModalTitle": "Penyesuaian Debit Pakan",
    "calibrationModalSubtitle": "Input data sesuai kondisi dan kami akan menyesuaikan debit untuk pemberian pakan selanjutnya.",
    "calibrationChooseTitle": "Hari Ini, Pakan Saya",
    "under": "Habis lebih cepat",
    "over": "Masih tersisa",
    "actualEndTime": "Pakan habis pada pukul",
    "actualEndTimeAsk": "Habis jam berapa?",
    "actualIntervalPeriod": "Durasi pakan habis",
    "remainingQuantity": "Perkiraan sisa pakan",
    "expectedQuantity": "Total pakan sebelumnya",
    "confirmationTitle": "Apakah data sudah benar?",
    "confirmationButton": "Ya, Sudah Benar",
    "changes": "Perubahan:",
    "debitBefore": "Debit sebelum",
    "debitAfter": "Debit setelah",
    "cancelButton": "Kembali",
    "successTitle": "Berhasil Disimpan!",
    "successSubtitle": "Penyesuaian akan dilakukan pada pemberian pakan berikutnya.",
    "close": "Tutup"
  },

  "autoFeederPondActivityListScreen": {
    "title": "Aktifitas Auto Feeder",
    "subtitle": "dalam seminggu terakhir"
  },

  "autoFeederPondEditScreen": {
    "title": "Pengaturan Auto-feeder",

    "connection": "Koneksi",
    "general": "Umum",
    "normal": "Normal",
    "continuous": "Kontinu",
    "misc": "Lainnya",
    "testRunAsto": "Uji Coba Asto",

    "bluetooth": "Bluetooth",
    "wifi": "WiFi",
    "ssid": "SSID",
    "password": "Password",

    "mode": "Mode",
    "debit": "Debit Pakan (gr/dtk)",
    "throwDebit": "Debit Pakan (gr/lontar)",
    "startTime": "Jam Mulai",
    "endTime": "Jam Selesai",
    "onTime": "Timer ON (detik)",

    "timesPerDay": "Jumlah pakan per hari",
    "timesPerPeriod": "Jumlah lemparan per jam pakan",
    "intervalPerPeriod": "Throw interval (menit)",
    "intervalPeriod": "Durasi pakan (menit)",

    "onTimeUnit": "detik",

    "testRun": "Test Run",
    "clearSetting": "Reset Setting",
    "disconnect": "Putus Sambungan",
    "delete": "Hapus",

    "connected": "Tersambung",
    "disconnected": "Terputus",
    "connecting": "Menyambungkan...",
    "tapToReconnect": "Sentuh untuk menyambungkan",
    "tapToConnect": "Sentuh untuk menyambungkan",
    "tapToRefresh": "Sentuh untuk Refresh",

    "failedToConnect": "Gagal Menyambungkan",
    "continuousSetting": "Pengaturan Dasar untuk Mode Kontinu",
    "normalSetting": "Pengaturan Dasar untuk Mode Normal"
  },

  "autoFeederPondForm": {
    "farmId": "Tambak",
    "pondId": "Kolam",
    "id": "ID",
    "name": "Nama",
    "mode": "Mode",
    "updatedAt": "Update Terakhir",
    "autoFeeder": "Auto Feeder",

    "farmIdPlaceholder": "Pilih Tambak",
    "pondIdPlaceholder": "Pilih Kolam",
    "idPlaceholder": "ID",
    "namePlaceholder": "Nama",
    "modePlaceholder": "Mode",
    "updatedAtPlaceholder": "Update Terakhir",
    "autoFeederPlaceholder": "Pilih Auto Feeder",

    "enableBluetoothTitle": "Enable Bluetooth",
    "enableBluetoothSubtitle": "Once Bluetooth is active, you can proceed with adding asto to your device.",
    "enableBluetoothConfirm": "ENABLE",
    "enableBluetoothCancel": "LATER"
  },

  "farmPondListScreen": {
    "header": "Buat Kolam",
    "title": "Kolam",
    "lastUpdate": "Update terakhir %{datetime}",
    "noUpdate": "tidak ada data dalam seminggu terakhir",
    "noRecord": "Tidak ada catatan siklus",
    "number": "Jumlah Kolam",
    "pondName": "Nama Tambak",
    "total": "{{pond}} kolam",
    "pondTooltip": "Buat kolam agar Anda dapat segera mencatatkan data.",
    "createCycle": "Mulai siklus untuk menikmati layanan Jala",

    "initialDataLoading": "Memuat Data Awal"
  },
  "farmAutoFeederPondListScreen": {
    "title": "Auto Feeder",
    "asto": "Asto",
    "addAsto": "Tambah Asto",
    "astoList": "Daftar Asto",

    "feed": "Pakan: %{feed} kg",
    "noDevices": "Tidak ada alat",
    "mode": "Mode: %{mode}",
    "todayFeed": "Pakan hari ini",
    "lastUpdate": "Update terakhir",
    "lastUploaded": "Unggah terakhir",
    "playMode": "Mode putar",
    "nextDayFeed": "Pakan hari berikutnya",

    "farm": "Tambak",
    "normal": "Normal",
    "continuous": "Kontinu",

    "emptyStateTitle": "Anda belum menambahkan Asto",
    "emptyStateSubtitle": "Untuk menggunakan fitur ini, Anda perlu menambahkan Asto terlebih dahulu.",
    "emptyStateButton": "Tambahkan Asto",

    "orderTitle": "Belum punya Asto?",
    "orderButton": "Pesan Sekarang",

    "cycleClosedTitle": "Tidak ada siklus aktif",
    "cycleClosedSubtitle": "Anda perlu membuat siklus baru.",
    "cycleLaterButton": "NANTI",
    "createCycleButton": "BUAT SIKLUS"
  },
  "measurementCreateScreen": {
    "title": "Tambah Pencatatan Kualitas Air"
  },
  "measurementEditScreen": {
    "title": "Ubah Pencatatan"
  },

  "createPondForm": {
    "farm": "Buat kolam untuk tambak",
    "prefix": "Nama awalan kolam",
    "name":"Nama Kolam",
    "length":"Panjang (m)",
    "width":"Lebar (m)",
    "wide": "Luas (m2)",
    "depth": "Kedalaman (m)",
    "type": "Jenis Kolam",
    "square": "Kotak",
    "circle": "Bundar",
    "diameter": "Diameter (m)",
    "nameError": "Nama telah digunakan di kolam Anda yang lain",
    "prefixDisclaimer": "Penomoran akan otomatis mengikuti jumlah kolam",
    "inputTitle": "Daftar kolam",
    "inputDisclaimer": "Ubah luas kolam sesuai aktual agar perhitungan estimasi Jala lebih sesuai.",

    "namePlaceholder":"Nama Kolam",
    "lengthPlaceholder":"-",
    "widthPlaceholder":"-",
    "widePlaceholder": "-",
    "depthPlaceholder": "-",
    "diameterPlaceholder": "-",
    "prefixPlaceholder": "Nama awalan kolam",
  },

  "quickInput": {
    "farming": "Budidaya",
    "daily": "Harian",
    "LabTest": "Tes Laboratorium",
    "Others": "Lain-lain",
    "startCycle": "Mulai Siklus",
    "sampling": "Sampling",
    "harvest": "Panen & Parsial",
    "closeCycle": "Tutup Siklus",
    "createFarm": "Buat Tambak",
    "createPond": "Buat Kolam",
    "feed": "Pakan",
    "waterQuality": "Kualitas Air",
    "treatment": "Perlakuan",
    "feedingTray": "Anco",
    "chemical": "Kimia",
    "microbiology": "Mikrobiologi",
    "plankton": "Plankton",
    "disease": "Penyakit",
    "mortality": "Kematian",
    "quickInputTitle": "Pencatatan Cepat"
  },

  "phoneInput": {
    "chooseCountry": "Pilih Negara"
  },

  "picker": {
    "choose": "Pilih"
  },

  "bluetoothPicker": {
    "scanQr": "Pindai QR"
  },

  "predictions": {
    "activePond": "Kolam aktif",
    "#": "#",
    "biomasPrediction": "Prediksi Biomasa",
    "feedCumulative": "Pakan Kumulatif",
    "SrPrediction": "Prediksi SR",
    "SeliingPricePrediction": "Prediksi Nilai Jual"
  },

  "monitoring": {
    "batch": "Batch",
    "label": "Pilih Batch",
    "cyclesCount": "Siklus",
    "disclaimer": "Lengkapi data Anda agar perhitungan estimasi di aplikasi lebih mendekati kondisi di lapangan. Ada keluhan mengenai JALA App?",
    "feedback": "Beri Jala kritik/saran",
    "weight": "MBW (g)",
    "size": "Size",
    "totalWeight": "Total biomasa (kg)",
    "harvestAccumulationWeight": "Panen kumulatif (kg)",
    "adg": "ADG (g)",
    "feedAccumulation": "Total Pakan (kg)",
    "survivalRate": "Estimasi SR (%)",
    "fcr": "Estimasi FCR",
    "disclaimerMonitoring": "Lengkapi data pakan dan sampling agar estimasi lebih akurat",
    "disclaimerMonitoringBefore30": "Lengkapi data pakan agar estimasi lebih akurat",
    "seePond": "Lihat Kolam",
    "parameter": "Parameter",
    "actual": "Aktual (DoC)",
    "pondPopulate": "Populasi dikolam (%)",
    "estimation": "Estimasi hari ini",
    "empty": "Data tidak ditemukan"
  },

  "samplingInput": {
    "title":"Tambah Data Sampling",
    "inputTitle": "Sampling"
  },

  "treatmentInput": {
    "title":"Tambah Data Perlakuan"
  },

  "harvestInput": {
    "title": "Tambah Data Panen",
    "inputTitle": "Panen"
  },

  "cycleDiseaseInput": {
    "title": "Tambah Data Penyakit"
  },

  "chemical": {
    "header": "Kimia",
    "date": "Tgl (DoC)",
    "Ammonia": "NH3",
    "Nitrit": "NO2",
    "Alkalinity": "Alkalinitas",
    "more": "Opsi",
    "inputTitle":"Tambah Data Kimia",
    "changeParam": "Atur tampilan parameter"
  },

  "chemicalForm" : {
    "farmId": "Tambak",
    "pondId": "Kolam",
    "header": "Tes Kimia",
    "measuredDate": "Tanggal",
    "ammonia": "Amonia (NH3) (ppm)",
    "nitrit": "Nitrit (NO2) (ppm)",
    "alkalinity": "Alkalinitas (ppm)",
    "ammonium": "Amonium (NH4) (ppm)",
    "nitrat": "Nitrat (NO3) (ppm)",
    "carbonat": "karbonat (CO3) (ppm)",
    "bicarbonat": "Bikarbonat (HCO3) (ppm)",
    "hardness": "Kesadahan (ppm)",
    "calcium": "Kalsium (Ca) (ppm)",
    "magnesium": "Magnesium (Mg) (ppm)",
    "phosphate": "Fosfat (PO4) (ppm)",
    "tom": "Jumlah bahan organik (TOM) (ppm)",
    "orp": "Potensial oksidasi-reduksi (ORP) (ppm)",

    "farmIdPlaceholder":"Pilih tambak",
    "pondIdPlaceholder": "Pilih kolam",
    "measuredDatePlaceholder": "Pilih tanggal",
    "ammoniaPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "nitratPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-"
  },

  "pondProfileForm": {
    "setting": "Pengaturan Kolam",
    "delete": "Hapus Kolam",
    "name": "Nama Kolam",
    "rfid": "Nomor RFID (Opsional)",
    "rfidTitle": "Nomor RFID",
    "rfidSubtitle": "RFID merupakan sebuah kartu yang didapat saat pembelian Baruno, di dalamnya terdapat 8 digit kode yang bisa didaftarkan untuk mengidentifikasi kolam.",
    "length": "Panjang (m)",
    "width": "Lebar (m)",
    "diameter": "Diameter (m)",
    "area": "Luas (m2)",
    "deep": "Kedalaman (m)",
    "createdAt": "Didirikan pada",
    "feedingTrayCount": "Anco",
    "type": "Jenis Kolam",
    "square": "Kotak",
    "circle": "Bundar",
    "existingName": "Nama ini sudah dipakai di kolam lain",
    "warning": "Perubahan luas kolam tidak berpengaruh pada perhitungan estimasi di siklus yan telah dibuat sebelumnya. Namun akan mempengaruhi perhitungan pada siklus selanjutnya.",
    "rfidNotFound": "Tidak ada data yang sesuai",
    "rfidLabel": "RFID",
    "success": "Data berhasil disimpan",
    "failed": "Data gagal disimpan, mohon cek koneksi internet Anda dan coba lagi",
    "editPondDesc": "Perubahan luas kolam tidak berpengaruh pada perhitungan estimasi di siklus yan telah dibuat sebelumnya. Namun akan mempengaruhi perhitungan pada siklus selanjutnya.",
    "visit": "*Kunjungi",

    "namePlaceholder": "Nama Kolam",
    "rfidPlaceholder": "Masukkan 8 huruf kode",
    "lengthPlaceholder": "-",
    "widthPlaceholder": "-",
    "areaPlaceholder":"-",
    "deepPlaceholder": "-",
    "diameterPlaceholder": "-",
    "createdAtPlaceholder": "Pilih tanggal",
    "feedingTrayCountPlaceholder": "Pilih Anco",

    "deleteModalTitle": "Apakah anda yakin ingin hapus Kolam?",
    "deleteModalSubtitle": "Jika Anda yakin ketik ",
    "deleteModalSubtitleLast": "untuk mengkonfirmasi kolam yang ingin dihapus.",
    "pondNamePlaceholder": "Ketikan nama kolam",
    "confirmDeleteButton": "YA, HAPUS",
    "cancelDeleteButton": "BATALKAN",
    "modalErrorMessage": "Ketikan “{{pond}}”"
  },

  "cycleHistoryScreen": {
    "header": "Riwayat Siklus",
    "days": "hari",
    "kg": "kg",
    "percent": "%",
    "age": "Umur",
    "harvest": "Panen",
    "seed": "Tebaran",
    "fcr": "FCR",
    "size": "Size akhir",
    "survival": "SR"
  },

  "personalisationScreen": {
    "header": "Personalisasi Tampilan",
    "PersonalizationTitle": "Atur tampilan beranda sesuai kebutuhan",
    "PersonalizationSubtitle": "Pilih satu atau lebih dibawah ini. Pilihan ini akan menentukan tampilan yang akan muncul dan fitur yang dapat Anda akses.",
    "button": "Lanjutkan"

  },

  "verificationScreen": {
    "title": "Verifikasi nomor HP Anda",
    "subtitle": "Cek kode OTP yang kami kirimkan ke nomor HP {{phone}}",
    "subtitleOld": "Bantu kami mengecek otentikasi nomor HP Anda dengan memasukkan kode OTP yang kami kirimkan ke {{phone}}",
    "warningOld": "Segera Verifikasi nomor HP Anda ({{day}} hari {{hour}} jam)",
    "verificationInfo": "Nikmati fasilitas Jala setelah melakukan verifikasi",
    "codeVerificationError": "Kode OTP yang anda masukan salah atau kadaluwarsa",
    "placeholderOTP": "6 digit kode OTP",
    "resendOTP": "Kirim ulang OTP",
    "cantVerify": "Gagal mendapatkan OTP?",
    "contactUs": " Hubungi kami",
    "verificationButton": "Masukkan kode OTP",
    "inputBeforeExpired": "Segera masukkan OTP dalam {{seconds}} detik",
    "changePhoneTitle": "Ubah nomor HP",
    "changePhoneSubtitle": "Kode OTP akan segera kami kirim ke nomor telepon yang Anda masukkan di bawah ini",
    "verification": "Verifikasi",
    "verificationWarning": "Verifikasi nomor HP Anda ({{day}} hari)",
    "inputPhoneTitle": "Masukkan nomor telepon",
    "inputPhoneSubtitle": "Bantu kami melakukan verifikasi pada akun Anda, mulai dengan memasukkan nomor telepon.\nKode OTP akan dikirimkan melalui SMS.",
    "changeNumberButton": "Ubah nomor dan kirim ulang OTP",
    "verifExpired": "Lakukan verifikasi untuk melanjutkan ke dashboard",
    "whatsappMessageVerification": "Tolong bantu saya memverifikasi nomor telepon {{phoneNumber}}",
    "whatsappMessageVerificationEmail": "Tolong bantu saya memverifikasi email {{email}}",
    "changePhone": "Ubah nomor",
    "phoneVerificationTitle": "Verifikasi Nomor",
    "phoneChangeTitle": "Ubah Nomor",

    "phoneWarning": "Tidak dapat mengubah nomor karena baru diubah dalam 24 jam terakhir",
    "phoneError": "Nomor HP harus berupa nomor yang valid",
    "phoneDisclaimer": "Anda hanya dapat mengubah nomor 1 kali dalam 24 jam. Hubungi Kami untuk pertanyaan lainnya.",

    "verificationFailed": "Verifikasi nomor gagal",
    "OTPLimited": "Gagal mendapatkan OTP\nGunakan nomor lain atau Hubungi Kami."
  },

  "infoAppScreen": {
    "title": "Info Aplikasi",
    "header": "Aplikasi manajemen budidaya udang",
    "thanks": "Terima kasih kepada beta tester",
    "madeIn": "Made in Indonesia",
    "credit": "© 2022 PT JALA Akuakultur Lestari Alamku"
  },

  ...components,
  ...forms,
  ...screens,
  ...models,
  ...commons,
  yup,

  "privacyPolicy": "Kebijakan Privasi",

  "thunderStorm": "Hujan Lebat",
  "rain": "Hujan",
  "drizzle": "Gerimis",
  "cloudy": "Berawan",
  "sunnyCloudy": "Cerah Berawan",
  "sunny": "Cerah",
  "scorching": "Panas Terik",
  "none": "tidak ada",

  "yellow": "Kuning",
  "yellowGreen": "Kuning kehijauan",
  "brown": "Coklat",
  "brownGreen": "Coklat kehijauan",
  "darkBrown": "Coklat gelap",
  "lightBrown": "Coklat muda",
  "brownRed": "Coklat kemerahan",
  "green": "Hijau",
  "greenBrown": "Hijau kecoklatan",
  "greenBlue": "Hijau kebiruan",
  "darkGreenBrown": "Hijau gelap kecoklatan",
  "darkGreen": "Hijau gelap",
  "black": "Hitam",

  "Search": "Cari",
  "Clear": "Hapus",
  "Close": "Tutup",
  "Finished": "Selesai",
  "Please Wait": "Harap Tunggu",
  "Network Error": "Kesalahan Jaringan",
  "language": "Bahasa",
  "total": "Total",
  "average": "Rata-rata",
  "million": "Juta",
  "millionPerKg": "/kg",
  "doc": "DoC",
  "Today": "Hari ini",
  "SRWithPercent": "SR(%)",
  "Size": "Size",
  "Biomass": "Biomasa",
  "harvest": "Panen",
  "cycle": "Siklus",
  "date": "Tanggal",
  "time": "Waktu",
  "noPond": "Tidak ada Kolam",
  "save": "Simpan",
  "connect": "Sambungkan",
  "add": "Tambah",
  "edit": "Ubah",
  "delete": "Hapus",
  "cancel": "Batal",
  "reset": "Reset",
  "upload": "Unggah",
  "uploading": "Mengunggah",
  "override": "Timpa",
  "failed": "Gagal",
  "success": "Berhasil",
  "offlineModeContent": "Data disimpan sementara di perangkat Anda. Segera upload data ketika sinyal sudah memadai.",
  "offlineModeWeakConnection": "Koneksi Lemah",
  "Errors": "Error",
  "farmingSummary": "Ringkasan Budidaya",
  "cycleHistory": "Riwayat Siklus",
  "pondProfile": "Pengaturan Kolam",
  "cycleProfile": "Pengaturan Siklus",
  "searchPondPlaceholder": "Cari Kolam...",
  "paramTooltip": "Klik di sini untuk memasukkan data parameter lainnya",

  "and": "dan",
  "noData": "tidak ada data",

  "areYouSureYouWantTo": "Apakah anda yakin untuk %{something}?",

  "LongNet": "Netto (Jumlah benur yang diorder)",
  "LongGross": "Bruto (Sesuai kiriman hatchery)",
  "LongActual": "Aktual (Sesuai hitungan)",

  "Net": "Netto",
  "Gross": "Bruto",
  "Actual": "Aktual",

  "cantBeZero": "Inputan tidak boleh 0",
  "validationInput": "Inputan ini harus diisi",
  "otherParameters": "Parameter lainnya",
  "minPassword": "Kata sandi minimal 6 karakter",
  "cantBeMinus": "Input tidak boleh kurang dari 0",

  "filter": "Filter",
  "addNote": "Catatan",

  "now": "Sekarang",

  "fetchingData": "Mengambil data...",
  "offline": "Data offline",

  "changeLanguage": {
    "title": "Pilihan Bahasa",
    "Indonesia": "Bahasa Indonesia (ID)",
    "english": "Bahasa Inggris (EN)",
    "vietnamese": "Bahasa Vietnam (VN)",
    "espanol": "Español (ES)"
  },

  "checkLink": "Cek link berikut: {{url}}",
  "shareDiseaseTitle": "Info penyakit udang: {{disease}}",
  "failedShared": "Data gagal disebarkan, coba kembali beberapa saat lagi",
  "shareNewsTitle": "Sudahkah baca artikel Jala yang ini? {{news}}.",
  "sharePriceTitle": "Update {{date}}, Harga udang size 100 - {{region}}.",
  "copiedToClipboard": "Disalin ke papan klip",

  "posts": {
    "read_complete_article_only_on": "baca artikel lengkapnya hanya di"
  },

  "notifications": {
    "infoHeader": "Harga Udang",
    "farmingHeader": "Budidaya",
    "priceNotificationTitle": "Harga udang terbaru daerah",
    "readAll": "Tandai semua dibaca",
    "waitingForLoad": "Memuat Notifikasi Baru",
    "emptyNotification": "Tidak Ada Notifikasi Baru",
    "refreshPage": "Refresh Halaman",
  },

  "NewFeature": "Baru! {{featureName}}",
  "AlertFailedTitle": "Gagal",
  "AlertFailedAuthSubtitle": "Gagal masuk",
  "AlertFailedRegisSubtitle": "Pendaftaran gagal",
  "AlertWrongInput": "Email atau Kata sandi salah",
  "AlertServerUnreachable": "Server tidak terjangkau",
  "AlertServerFail": "Maaf, ada masalah dengan server kami",
  "AlertUserNotFound": "Pastikan username dan password anda sudah benar",
  "AlertUserUnauthenticated": "User tidak ditemukan, silahkan registrasi terlebih dahulu",
  "AppleSignInNotSupported": "Mohon maaf, versi iOs anda tidak dapat masuk menggunakan Apple ID. Mohon perbaharui versi iOs anda, atau masuk menggunakan opsi lainnya",

}
